import React from 'react'
import { useSelector } from 'react-redux'

const ButtonBookmark = ({outlineColor, className, style, onClick, active, thin, transparent, disabled}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  return (
    <button
      className={`${transparent ? '' : 'bg-white'} border uppercase font-accent rounded text-center ${thin ? 'p-2' : 'p-4'} w-full text-sm ${disabled ? 'text-gray-999' : ''} ${className}`}
      style={{
        borderColor: outlineColor === 'primary' ? '#ddd' : '#ddd',
        ...style
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {
        active ? (
          <div className="w-full flex items-center justify-center">
            <div><img className="mr-2" src="/images/icons/khub_bookmark_active.svg" alt="bookmark"/></div>
            <div>{translation.BOOKMARK.bookmarked[language.name]}</div>
          </div>
        ) : (
          <div className="w-full flex items-center justify-center">
            <div><img className="mr-2" src="/images/icons/khub_bookmark.svg" alt="bookmark"/></div>
            <div>{translation.BOOKMARK.bookmark_action[language.name]}</div>
          </div>
        )
      }
    </button>
  )
}

export { ButtonBookmark }
